import React from "react";
import Dropzone from "react-dropzone";
import { Card, CardBody, CardHeader } from "reactstrap";
import { FileExcelOutlined, HourglassOutlined } from "@ant-design/icons";
import { Bs2Circle } from "react-icons/bs";

const FileUpload = ({ selectedFiles, handleAcceptedFiles }) => {
  return (
    <Card>
      <CardHeader className="card-header">
        <h4 className="card-title mb-0"><Bs2Circle /> Fichier Excel à uploader</h4>
      </CardHeader>
      <CardBody className="card-animate">
        <p className="text-muted text-center">Après avoir rempli le fichier téléchargé, Vous pouvez l'uploader ici.</p>
        <Dropzone onDrop={handleAcceptedFiles}>
          {({ getRootProps, getInputProps }) => (
            <div className="dropzone dz-clickable">
              <div className="dz-message needsclick" {...getRootProps()}>
                <div className="mb-3">
                  <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                </div>
                <h6> Déposer ou parcourir le fichier excel </h6>
              </div>
            </div>
          )}
        </Dropzone>
        <div className="list-unstyled mb-0" id="file-previews">
          {selectedFiles.map((f, i) => (
            <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete" key={i + "-file"}>
              <div className="p-2">
                <div>
                  <FileExcelOutlined /> Fichier : <strong>{f.name}</strong>
                </div>
                <p className="mb-0 text-muted font-weight-bold">
                  <HourglassOutlined /> Taille : <strong>{f.formattedSize}</strong>
                </p>
              </div>
            </Card>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default FileUpload;
